import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/site/unit";
const apiCheckEndPoint=API_BASE_URL_ENV() +"/website/user/buy-now"
const Cilapi=API_BASE_URL_ENV() +"/website/user/send-cil" 

 export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    checkProperty = (data) => {
        return http.post(apiCheckEndPoint,data)
    }

    sendCil=(data)=>{
        return http.post(Cilapi, data);

    }
}
